<template>
  <div>
    <div class="crossSellRow" v-if="ready" v-for="(_, i) of value" :key="`cs-${i}`">
      <CrossSellRow
        v-model="value[i]"
        :inventory-id="inventoryId"
        :ignore="ignoredItemIds"
        :initial-name-cache="nameCache"
      />
      <div>
        <button class="btn btn-primary" @click="removeRow(i)">X</button>
      </div>
    </div>
    <div class="buttonsRow">
      <button class="btn btn-primary" @click="addRow">Add Cross Sell</button>
    </div>
  </div>
</template>

<script>

import {Core} from "@/core/Core";
import CrossSellRow from "@/components/qsr/CrossSellRow";

export default {
  name: "CrossSells",
  components: {CrossSellRow},
  props: {
    value: Array,
    inventoryId: Number,
    itemId: Number
  },

  computed: {
    ignoredItemIds() {
      return this.itemId ? [this.itemId] : []
    }
  },

  data() {
    return {
      ready: false,
      nameCache: {}
    }
  },

  async mounted() {
    let missingIds = this.value
      .filter(e => !this.nameCache.hasOwnProperty(e.item.toString()))
      .map(e => e.item);

    if (missingIds.length) {
      let response = await Core.request('GET', `/api/entity/orderable/select`, {inventory: this.inventoryId, id: missingIds});
      for (let row of response) {
        this.nameCache[row.id.toString()] = row.name;
      }
    }
    this.ready = true;
  },

  methods: {
    addRow() {
      this.value.push({ item: null, link: '->' });
    },
    removeRow(index) {
      this.value.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.crossSellRow {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 3px solid rgba(252, 102, 80, 0.55);

  > :first-child {
    width: 100%;
  }
  > :last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
  }
}
.buttonsRow {
  text-align: center;
}
</style>